import { render, staticRenderFns } from "./FuelConsumptionTrendChart.vue?vue&type=template&id=002555a5&scoped=true&"
import script from "./FuelConsumptionTrendChart.vue?vue&type=script&lang=js&"
export * from "./FuelConsumptionTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./FuelConsumptionTrendChart.vue?vue&type=style&index=0&id=002555a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002555a5",
  null
  
)

export default component.exports